import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { FormControl, type FormGroup } from '@angular/forms';
import { map, type Observable, shareReplay } from 'rxjs';

import { environment } from '../../../environments/environment';
import { type Language } from '../../modules/user-management/users/user.model';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {
  private http = inject(HttpClient);

  private readonly apiUrl = `${environment.apiBaseUrl}`;
  private languages$?: Observable<Language[]>;

  getLanguagesForDropdown(): Observable<Language[]> {
    return this.getLanguages();
  }

  addLanguageControls(form: FormGroup, languages: Language[]): void {
    const displayNamesGroup = form.get('displayNames') as FormGroup | null;
    const displayDescriptionsGroup = form.get('displayDescriptions') as FormGroup | null;

    languages.forEach(lang => {
      if (displayNamesGroup) {
        displayNamesGroup.addControl(lang.code!, new FormControl(''));
      }

      if (displayDescriptionsGroup) {
        displayDescriptionsGroup.addControl(lang.code!, new FormControl(''));
      }
    });
  }

  getLanguages(): Observable<Language[]> {
    if (!this.languages$) {
      this.languages$ = this.http.get<Language[]>(`${this.apiUrl}/language/find-all-for-dropdown`).pipe(shareReplay(1));
    }
    return this.languages$;
  }

  getCurrentLanguageId(langCode: string): Observable<string> {
    return this.getLanguages().pipe(map(langs => langs.find(lang => lang.code === langCode)?.id ?? ''));
  }
}
